import React from 'react';
import styles from './Toggle.module.scss';

export interface ToggleProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

const Toggle: React.FC<ToggleProps> = ({ id, checked, onChange, label, disabled = false }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  return (
    <div className={styles.toggleContainer}>
      <label htmlFor={id} className={styles.toggleWrapper}>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          className={styles.toggleInput}
        />
        <span className={styles.toggleSlider} />
      </label>
      {label && <span className={styles.toggleLabel}>{label}</span>}
    </div>
  );
};

export default Toggle;
